module.exports = __webpack_public_path__ + "img/hemd-52-blauw-slim-fit-opstaande.fdd4133f.png";